export default "__VITE_ASSET__f64ffc51__"